export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14346.a7cffb04.jpg";